import type { ISummaryBox } from "@app/dashboard/types/innerLayout/cards/summary-box";

import { LabeledBox } from "../LabeledBox";
import { SummaryBox } from "@app/dashboard/components/inner_layout/Cards/SummaryBox";
import styles from "./details-box.module.scss";


export const DetailsBox = ({
  label,
  itemsList
}: {
  label?: string,
  itemsList?: ISummaryBox['itemsList']
}) => {

  return (
    <div className={styles["details-box"]}>
      <LabeledBox
        label={label}
      >
        <SummaryBox
          width="100%"
          height="fit-content"
          itemsList={itemsList}
        />
      </LabeledBox>
    </div>
  )
}
